// ===============================
// Sticky ATC behavior controller
// ===============================

/** @type {HTMLElement | null} */
const bottomATC = document.querySelector('.bottom-atc');
/** @type {HTMLElement | null} */
const mainATC = document.querySelector('.product-action .addToCartBtn');

let passedMainATC = false;

// --- Function: Adjust Customer Hub Position ---
/** @param {boolean} shouldPush */
function adjustCustomerHub(shouldPush) {
  /** @type {HTMLElement | null} */
  const hubWidget = document.querySelector('[class^="HubLauncherWidget__FloatingWidget-sc"]');
  
  // Guard clause: ensure hubWidget and bottomATC exist before accessing .style or .offsetHeight
  if (!hubWidget || !bottomATC) return;

  if (shouldPush) {
    // Calculate current height plus a 15px buffer
    const offset = bottomATC.offsetHeight;
    hubWidget.style.transform = `translateY(-${offset}px)`;
    hubWidget.style.transition = 'transform 0.3s ease-in-out';
  } else {
    hubWidget.style.transform = 'translateY(0px)';
  }
}

// --- Observe main ATC visibility ---
// Only run if both elements were found on the page
if (mainATC && bottomATC) {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        bottomATC.classList.remove('show');
        bottomATC.classList.add('hide');
        adjustCustomerHub(false);
      }
    },
    { threshold: 0 }
  );

  observer.observe(mainATC);

  // --- Scroll position detection ---
  window.addEventListener('scroll', () => {
    const currentScrollY = window.scrollY;

    // Calculate position
    const mainATCBottom = mainATC.getBoundingClientRect().bottom + window.scrollY;

    passedMainATC = currentScrollY > mainATCBottom;

    if (passedMainATC) {
      bottomATC.classList.add('show');
      bottomATC.classList.remove('hide');
      adjustCustomerHub(true);
    } else {
      bottomATC.classList.remove('show');
      bottomATC.classList.add('hide');
      adjustCustomerHub(false);
    }
  });
}